import React, { useState } from 'react';
// import GoogleLogo from '../assets/googleicon.svg';
import { useNavigate } from 'react-router-dom';
import { useCommonDataContext } from '../context/CommonDataProvider';

export default function LoginForm() {
  // Accessing common data context
  const { dataFetch } = useCommonDataContext();
  // State to manage invalid input
  const [invalid, setInvalid] = useState(false);

  // State to manage form data
  const [data, setData] = useState({
    email: '',
    password: '',
  });

  // Function to handle input changes
  const handleChange = (e) => {
    // Resetting invalid state if it was previously set
    if (invalid) {
      setInvalid(false);
    }
    const { name, value } = e.target;
    // Updating form data
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Accessing navigation function from react-router-dom
  const navigate = useNavigate();

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      // Handling different response statuses
      if (response.status === 400 || response.status === 500 || response.status === 401) {
        setInvalid(true);
      }
      if (response.ok) {
        const responseData = await response.json();
        // Assuming the response contains a token field
        const token = JSON.stringify(responseData);
        const userDetails = responseData;
        // let token = userDetails ? userDetails.result.token : null;
        // Storing the token in local storage
        localStorage.setItem('token', token);
        // Triggering data fetch
        dataFetch();
        // Navigating to the appropriate landing page based on role
        if(['ADMIN', 'SUPER_USER', 'RBM', 'ABM', 'REPRESENTATIVE'].includes(userDetails.result.role)){
          navigate('/home')
        }else{
        navigate('/fileuploaddetails');
        }
      } else {
        console.error('Error logging in:', response.statusText);
        // Handle error if needed
      }
    } catch (error) {
      console.error('Error logging in:', error);
      // Handle error if needed
    }
  };  

  return (
    <div className='bg-white px-10 py-10 rounded-3xl border-2 border-gray-200'>
      <h1 className='text-3xl font-semibold'>Welcome Back</h1>
      <p className='font-medium text-lg text-gray-500 mt-4'>Welcome back! Please enter your details.</p>
      <div className='mt-8'>
        <div>
          <label className='text-lg font-medium'>Email</label>
          <input 
              className='w-full border-2 border-gray-100 rounded-xl p-3 mt-1 bg-transparent'
              placeholder='Enter your email'
              id='email'
              name='email'
              value={data.email}
              onChange={handleChange}
              required
          />
        </div>
        <div>
          <label className='text-lg font-medium'>Password</label>
          <input 
              className='w-full border-2 border-gray-100 rounded-xl p-3 mt-1 bg-transparent'
              placeholder='Enter your password'
              type='password'
              id='password'
              name='password'
              value={data.password}
              onChange={handleChange}
              required
          />
        </div>
        {invalid && <p className='text-center text-red-600 font-semibold mt-3'>**Invalid email or password**</p>}
       
        <div className='mt-8 flex flex-col gap-y-4'>
          <button className='flex p-2 rounded-xl border-2 border-gray-100 items-center justify-center bg-[#00dac4] text-white font-bold gap-2 active:scale-[0.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all' onClick={handleSubmit}>
            Login
          </button>
        </div>
      </div>
    </div>
  );
}
